import PropTypes from 'prop-types';
import React from 'react';
import Icon from 'ViatoUi/Shared/DataDisplay/Icon';
import { FlexBox } from 'ViatoUi/Shared/Layouts/Flex';
import Spacer from 'ViatoUi/Shared/Layouts/Spacer';

import styles from './Checkbox.module.scss';

const Checkbox = ({ checked, label, onToggle }) => {
	return (
		<FlexBox alignItems='flex-start' className={styles.checkBoxItem} onClick={() => onToggle()}>
			<div className={styles.checkBox} data-checked={checked}>
				<Icon className={styles.checkMark} color='primary' icon='fa-check' iconWeight='fas' size='l' />
			</div>
			<Spacer width='m' />
			{label}
		</FlexBox>
	);
};

Checkbox.propTypes = {
	checked: PropTypes.bool.isRequired,
	label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
	onToggle: PropTypes.func.isRequired
};

export default Checkbox;
